/**
 * Library packages + usage API client.
 * For Media Devoted | Created By Ciro Autiero
 */

import api from '@/services/api';
import type {
  FlowOptimizerLibraryProvider,
  FlowOptimizerLibraryUsage,
  FlowOptimizerPackage,
  FlowOptimizerPackageApplyResult,
  FlowOptimizerPackageExpanded,
} from '@trafficpulse/shared';

const BASE = '/flow-optimizer-library';

export interface PackageWriteBody {
  name?: string;
  description?: string;
  color?: string;
  labels?: string[];
  formulaSetId?: string;
  ruleSetId?: string;
}

export async function listPackages(): Promise<FlowOptimizerPackage[]> {
  const { data } = await api.get(`${BASE}/packages`);
  return (data.data ?? data) as FlowOptimizerPackage[];
}

export async function getPackage(
  id: string,
): Promise<FlowOptimizerPackageExpanded> {
  const { data } = await api.get(`${BASE}/packages/${id}`);
  return (data.data ?? data) as FlowOptimizerPackageExpanded;
}

export async function createPackage(
  body: PackageWriteBody & { name: string; formulaSetId: string; ruleSetId: string },
): Promise<FlowOptimizerPackage> {
  const { data } = await api.post(`${BASE}/packages`, body);
  return (data.data ?? data) as FlowOptimizerPackage;
}

export async function updatePackage(
  id: string,
  body: PackageWriteBody,
): Promise<FlowOptimizerPackage> {
  const { data } = await api.patch(`${BASE}/packages/${id}`, body);
  return (data.data ?? data) as FlowOptimizerPackage;
}

export async function deletePackage(id: string): Promise<void> {
  await api.delete(`${BASE}/packages/${id}`);
}

export async function applyPackage(
  id: string,
  body: { provider: FlowOptimizerLibraryProvider; campaignId: string },
): Promise<FlowOptimizerPackageApplyResult> {
  const { data } = await api.post(`${BASE}/packages/${id}/apply`, body);
  return (data.data ?? data) as FlowOptimizerPackageApplyResult;
}

export async function getLibraryUsage(): Promise<FlowOptimizerLibraryUsage> {
  const { data } = await api.get(`${BASE}/usage`);
  return (data.data ?? data) as FlowOptimizerLibraryUsage;
}
